import React, { FC } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { formatNumber, toOptionalFixed } from '@app/helpers/format';
import { formatUSD } from '@app/helpers/formatUSD';
import styles from './AmountSection.module.scss';
import cn from 'clsx';

interface Props {
  amount: number | string;
  usdAmount: number | null;
  classes?: {
    root?: string;
    amount?: string;
    usdAmount?: string;
  };
}

export const AmountSection: FC<Props> = ({ amount, usdAmount, classes }) => {
  return (
    <Flex className={cn(styles.root, classes?.root)}>
      <Text className={cn(styles.amount, classes?.amount)}>
        {+amount < 1
          ? toOptionalFixed(+amount, 2)
          : formatNumber(+amount, 2, { notation: 'compact' })}
      </Text>
      {usdAmount ? (
        <Text className={cn(styles.usdAmount, classes?.usdAmount)}>
          {formatUSD.format(usdAmount)}
        </Text>
      ) : null}
    </Flex>
  );
};
